import { numberFormatter } from '../../utils/number'
import { commodityPackageTypesMap, type CommodityPackageType } from '../domain/Commodity'
import { packageTypeLabelsMap, type PackageType } from '../domain/PackageType'

export function formatDimensionNumber(dimension: number): string {
  return numberFormatter(dimension, 2)
}

export function formatDimension(dimension: number | string): string {
  const parsedDimension = Number(dimension)
  if (Number.isNaN(parsedDimension)) {
    return ''
  }
  return formatDimensionNumber(parsedDimension)
}

export function formatVolume(volume?: number | string): string {
  const parsedVolume = Number(volume)
  if (Number.isNaN(parsedVolume)) {
    return ''
  }
  return `${formatDimensionNumber(parsedVolume)} ft³`
}

export function formatLinearFeet(linearFeet?: number | string): string {
  const parsedLinearFeet = Number(linearFeet)
  if (Number.isNaN(parsedLinearFeet)) {
    return '-'
  }
  return `${formatDimensionNumber(parsedLinearFeet)} ft`
}

type PackageTypeLabelData = {
  count: number
  category: 'items' | 'commodities'
  description?: string | undefined
  packageType?: PackageType | CommodityPackageType | ''
}

export function formatPackageTypeLabel(packageTypeLabelData: PackageTypeLabelData): string {
  if (!packageTypeLabelData.packageType) {
    return packageTypeLabelData.description ?? ''
  }

  let label: string | undefined
  if (packageTypeLabelData.category === 'commodities') {
    // Ideally if it is commodity package type, it should be within CommodityPackageType
    // However, we still have legacy commodity package types which were from PackageType
    label =
      commodityPackageTypesMap.get(packageTypeLabelData.packageType as CommodityPackageType) ??
      packageTypeLabelsMap.get(packageTypeLabelData.packageType as PackageType)
  } else {
    label = packageTypeLabelsMap.get(packageTypeLabelData.packageType as PackageType)
  }

  if (label) {
    return `${packageTypeLabelData.count} ${label.toLowerCase()}${
      packageTypeLabelData.description ? ` of ${packageTypeLabelData.description}` : ''
    }`
  }
  return packageTypeLabelData.description ?? ''
}
